import { Component, OnInit } from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-politica-privacidade',
  templateUrl: './politica-privacidade.component.html',
  styleUrls: ['./politica-privacidade.component.scss']
})
export class PoliticaPrivacidadeComponent implements OnInit {

  pdfUrl: any;

  constructor(private sanitize: DomSanitizer) {
    this.pdfUrl = this.sanitize.bypassSecurityTrustResourceUrl('assets/doc/politica_de_privacidade_minha_coleta.pdf')
  }

  ngOnInit(): void {
  }

}
